import { useEffect, useState } from "react";
import type { Command } from "../../domain/types/index.js";
import { loadPublishedStages } from "../stageMaker/customStagesClient.js";
import type { StoredStage } from "../stageMaker/stageRecord.js";
import { beginCustomPlay } from "./beginCustomPlay.js";
import { customPlayList } from "./customPlayList.js";
import { StageCard } from "./StageCard.js";

export function CustomPlayPanel({ dispatch }: { dispatch: (command: Command) => void }) {
  const [listed, setListed] = useState<StoredStage[] | null>(null);

  useEffect(() => {
    void loadPublishedStages(localStorage).then((stored) => setListed(customPlayList(stored)));
  }, []);

  if (listed === null) return <p className="hint">読み込み中</p>;
  if (listed.length === 0) {
    return <p className="hint">遊べる自作ステージはまだない</p>;
  }

  return (
    <ul className="stage-list">
      {listed.map((stage, index) => (
        <li key={stage.id}>
          <StageCard
            stage={{
              id: stage.id,
              name: stage.name,
              difficulty: stage.difficulty || "自作",
              flavor: stage.flavor,
              nodes: {},
            }}
            onStart={() => dispatch(beginCustomPlay(stage))}
            index={index}
          />
        </li>
      ))}
    </ul>
  );
}
